/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const ProjectItem = ({ data, handleDelete, add }) => {
    console.log(data.media);
    return (
        <div className="single-project">
            <div className="project-images">
                <Link
                    to={
                        process.env.PUBLIC_URL +
                        `/project-detalis/${data.title}`
                    }
                >
                    <img src={data.media.thumb} alt="Project" />
                </Link>
            </div>
            <div className="project-content d-flex">
                <h4 className="title">
                    <Link
                        to={
                            process.env.PUBLIC_URL +
                            `/project-detalis/${data.title}`
                        }
                    >
                        {data.title}
                    </Link>
                </h4>
                {sessionStorage.getItem("admin") && !add && (
                    <div>
                        <i
                            className="icofont-trash"
                            style={{
                                fontSize: "26px",
                                marginTop: "10px",
                                cursor: "pointer",
                                marginRight: "15px",
                            }}
                            onClick={() => {
                                handleDelete(data.title);
                            }}
                        />
                        <Link
                            to={
                                process.env.PUBLIC_URL +
                                `/edit-project/${data.title}`
                            }
                        >
                            <i
                                className="icofont-edit"
                                style={{
                                    fontSize: "26px",
                                    marginTop: "10px",
                                    cursor: "pointer",
                                }}
                            />
                        </Link>
                    </div>
                )}
            </div>
        </div>
    );
};

ProjectItem.propTypes = {
    data: PropTypes.object,
    handleDelete: PropTypes.any,
    add: PropTypes.bool,
};

export default ProjectItem;
